<div class="splash-container">
    <img src="assets/images/logo.png" alt="Image from above" class="image image1" [ngClass]="{'visible': isVisible, 'rotate-zoom': isRotated}">
    <img src="assets/images/aumye.png" alt="Image from below" class="image image2" *ngIf="!isRotated" [ngClass]="{'visible': isVisible}">
</div>